import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import editIcon from "../../assets/images/edit.svg";
import { Button } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import 'react-modern-drawer/dist/index.css'
import { Box } from '@material-ui/core';
import Loader from '../../components/loader/loader';
import { FaRegSquarePlus } from 'react-icons/fa6';
import { Tooltip } from "@mui/material";

const queueDatatableCustomStyles = {
    headCells: {
        style: {
            fontWeight: '600',
            fontSize: '14px'

        },
    },
    cells: {
        style: {
            fontSize: '12px',
            fontWeight: '500'
        },
    },

};
export const Users = () => {

    const navigate = useNavigate();

    const [data, setData] = useState([]);
    const [update, setUpdate] = useState(false)
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);


    const columns = [
        {
            name: "S. No.",
            selector: (row, index) => ((page * limit) - limit) + (index + 1),
            width: '90px'
        },
        {
            name: "First Name",
            selector: row => row.firstName,
            cell: (row) => <Tooltip title={row?.firstName} disableInteractive placement='top'><div className='text-truncate'>{row?.firstName}</div></Tooltip>,
            minWidth: '200px'
        },
        {
            name: "Last Name",
            selector: row => row.lastName,
            cell: (row) => <Tooltip title={row?.lastName} disableInteractive placement='top'><div className='text-truncate'>{row?.lastName}</div></Tooltip>,
            minWidth: '200px'
        },
        {
            name: "Email",
            selector: row => row.email,
            cell: (row) => <Tooltip title={row?.email} disableInteractive placement='top'><div className='text-truncate'>{row?.email}</div></Tooltip>,
            minWidth: '200px'
        },
        {
            name: "ACTION",
            cell: (row) =>
                <div>
                    <div className='d-flex flex-row gap-3' role='button'>
                        <Tooltip title="Edit" disableInteractive placement="top">
                            <div className="edit_icon_bg" onClick={() => navigate('/edit-user/' + row.id)}>
                                <img
                                    src={editIcon}
                                    alt="Edit"
                                    className="edit_icon"
                                />
                            </div>
                        </Tooltip>
                    </div>
                </div>,
            width: '150px'
        },
    ]


    useEffect(() => {

    }, [update])


    const handlePerRowsChange = (newPerPage, page) => {
        setLimit(newPerPage)
        setPage(1)
        setUpdate(!update)
    }
    const handlePageChange = (page) => {
        setPage(page)
        setUpdate(!update)
    }

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                        <h4 className="mb-sm-0">Users</h4>
                    </div>
                </div>
            </div>
            <div className="create-button-section">

                {/* <div className='d-flex gap-1'>
                        <div className='position-relative'>
                            <Form.Group controlId="exampleForm.ControlInput1">
                                <Form.Control
                                    type="text"
                                    placeholder="Search"
                                    className='filter-search'
                                    onChange={(e) => setSearch(e.target.value)}
                                />
                                <CiSearch className='custom-search-icon' />
                            </Form.Group>
                        </div>

                    </div> */}

                <div className='request_wrapper'>
                    <Button className='request_btn' onClick={() => navigate('/create-user')}><FaRegSquarePlus className='icon' />Add New</Button>
                </div>
                {/* 
                    <button class="btn btn-custom-primary btn-label" onClick={() => navigate('/create-user')}>
                        <div class="d-flex">
                            <div class="flex-shrink-0">
                                <IoIosAdd className="ri-user-smile-line label-icon align-middle fs-14 me-2" style={{ height: '100%' }} />
                            </div>
                            <div class="flex-grow-1">
                                Add new
                            </div>
                        </div>
                    </button> */}

            </div>



            <Box className="products-and-options" sx={{ mt: 1 }}>
                <Paper square>
                    <div>
                        <DataTable
                            columns={columns}
                            data={data}
                            progressPending={loading}
                            progressComponent={<div style={{ height: '60vh' }}><Loader /></div>}
                            pagination
                            paginationServer
                            paginationTotalRows={totalRows}
                            paginationPerPage={limit}
                            onChangeRowsPerPage={handlePerRowsChange}
                            onChangePage={handlePageChange}
                            customStyles={queueDatatableCustomStyles}
                        />
                    </div>
                </Paper>
            </Box>


        </>
    )
}
